import axios from 'axios'
import { authApiEndPoints } from '../constants/ApiEndPoints';
import { constants, getAuthItem } from '../utils/TokenManager';

// Request interceptor
axios.interceptors.request.use(function (config: any) {
  return new Promise((resolve, reject) => {
    // Skip adding token for token fetch request
    if (config.url === authApiEndPoints.tokenURL || config.url === authApiEndPoints.revokeURL) {
      resolve(config);
      return;
    }

    // Add token for all other requests
    let token = getAuthItem(constants.ID_TOKEN);
    if (config.url === authApiEndPoints.userInfoURL) {
      token = getAuthItem(constants.ACCESS_TOKEN);
    }

    if (!config?.url?.includes('s3.amazonaws.com') && token) {
      // eslint-disable-next-line camelcase
      config.headers.Authorization = `Bearer ${token}`;
    }
    resolve(config);
  })
})
export const handleError = (err: any) => {
  return new Promise((resolve, reject) => {
    if (err.response) {
      // client received an error response (5xx, 4xx)
      return reject(err?.response?.data)
    }
    if (err.request) {
      // client never received a response, or request never left
      return reject(err.request)
    }
    // anything else
    return reject(err)
  })
}

axios.interceptors.response.use(
  (response) => response,
  (error) => handleError(error),
)

// HTTP Methods
export default {
  getData: (url: string, params: any = null, headers = {}) =>
    axios({
      method: 'GET',
      url,
      params,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    }).then((response) => response),
  postData: (url: string, params: any = null, data: any = {}, headers = {}) => {
    return axios({
      method: 'POST',
      url,
      data,
      params,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    }).then((response) => response)
  },
  putData: (url: string, params: any = null, data: any = {}, headers = {}) =>
    axios({
      method: 'PUT',
      url,
      data,
      params,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    }).then((response) => response),
  deleteData: (url: string, params: any = null, data: any = {}, headers = {}) =>
    axios({
      method: 'DELETE',
      url,
      data,
      params,
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    }).then((response) => response),
}
